import React from 'react';
import {
    Dialog,
    DialogTitle,
    Button,
    DialogContent,
    Typography,
    DialogActions
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styles from "./styles.module.scss"

//TODO: change id of extension for treegress one, or enjoy the current one :)))
// const extensionId = "eejfnccgoejgidifcgpphjjfodmiofkm";

const ChromeExtensionModal = ({ open, onClose }) => {
    const navigate = useNavigate()

    const handleCancel = () => {
        onClose({ shouldOpenCreateModal: false });
    }

    const handleAlreadyInstalled = () => {
        // User confirmed they have extension, proceed to Create Journey modal
        onClose({ shouldOpenCreateModal: true });
    }

    const handleInstall = () => {
        // window.open(`https://chrome.google.com/webstore/detail/${extensionId}`, "_blank");
        navigate('/chrome-extension-setup');
    }

    return (
        <Dialog className={styles.extensionContent} open={open} onClose={handleCancel} fullWidth>
            <DialogTitle className={styles.title}>
                Setup Chrome Extension
            </DialogTitle>
            <DialogContent>
                <Typography>
                    In order to record a test journey, you need to have the Chrome
                    browser extension installed.
                </Typography>
            </DialogContent>

            <DialogActions className={styles.dialogActionsWrapper}>
                <Button
                    className={styles.setupButton}
                    onClick={handleInstall}
                    color="secondary"
                    type="button"
                    variant="outlined">
                    Setup
                </Button>
                <Button
                    className={styles.alreadyInstalledButton}
                    onClick={handleAlreadyInstalled}
                    color="secondary"
                    type="button"
                    variant="contained">
                    I already have the browser extension installed
                </Button>
            </DialogActions>
        </Dialog>

    );
};

export default ChromeExtensionModal;
